import { FileTextOutlined, TableOutlined } from '@ant-design/icons'
import { Button, Dropdown, theme } from 'antd'
import { ItemType } from 'antd/es/menu/interface'
import { t } from 'i18next'
import { useMemo } from 'react'
import styled from 'styled-components'

const { useToken } = theme

const StyledButton = styled(Button)`
  border-radius: 4px;
  box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.04);
  width: 32px;
  height: 32px;
`

export type SmartFunctionViewType = 'TABLE' | 'REPORT'

export const smartFunctionViewTypes = {
  TABLE: 'TABLE' as SmartFunctionViewType,
  REPORT: 'REPORT' as SmartFunctionViewType,
} as const

interface SmartFunctionViewTypeDropdownProps {
  value?: SmartFunctionViewType
  onChange?: (value: SmartFunctionViewType) => void
  disabled?: boolean
}

const SmartFunctionViewTypeDropdown = ({
  value = smartFunctionViewTypes.TABLE,
  onChange,
  disabled = false,
}: SmartFunctionViewTypeDropdownProps) => {
  const { token } = useToken()

  const selectedStyle = useMemo(() => {
    return {
      backgroundColor: token.colorPrimaryBg,
    }
  }, [token.colorPrimaryBg])

  const menuItems: ItemType[] = useMemo(
    () => [
      {
        label: t('Table'),
        key: smartFunctionViewTypes.TABLE,
        icon: <FileTextOutlined />,
        style: value === smartFunctionViewTypes.TABLE ? selectedStyle : {},
      },
      {
        label: t('Report'),
        key: smartFunctionViewTypes.REPORT,
        icon: <TableOutlined />,
        style: value === smartFunctionViewTypes.REPORT ? selectedStyle : {},
      },
    ],
    [selectedStyle, value]
  )

  return (
    <>
      <Dropdown
        menu={{
          items: menuItems,
          onClick: ({ key, domEvent }) => {
            domEvent.stopPropagation()
            if (onChange) {
              onChange(key as SmartFunctionViewType)
            }
          },
        }}
        placement="bottomRight"
        trigger={['hover']}
        disabled={disabled}
      >
        <StyledButton
          icon={<FileTextOutlined />}
          onClick={(e) => e.stopPropagation()}
        />
      </Dropdown>
    </>
  )
}

export default SmartFunctionViewTypeDropdown
